// Espelho de admin/src/components/Editor/Tiptap/extensions/Video/providers.js
// (contrato do conteúdo Tiptap 1.0, seção 3.3). Única diferença: entrada que
// não é string vira string vazia em vez de quebrar.
// O host passa por allowlist: um padrão solto aceitaria `evil.com/?youtube.com/watch?v=...`.
const PROVIDERS = [
	{
		provider: 'youtube',
		title: 'Vídeo do YouTube',
		hosts: [ 'youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com', 'youtu.be' ],
		id: /^[\w-]{11}$/,
		find: ({ hostname, pathname, searchParams }) => {
			if (hostname === 'youtu.be') return pathname.split('/')[1]
			if (pathname === '/watch') return searchParams.get('v')
			const [ , kind, id ] = pathname.split('/')
			return [ 'embed', 'shorts', 'live' ].includes(kind) ? id : null
		},
		embed: id => `https://www.youtube-nocookie.com/embed/${id}`,
	},
	{
		provider: 'vimeo',
		title: 'Vídeo do Vimeo',
		hosts: [ 'vimeo.com', 'www.vimeo.com', 'player.vimeo.com' ],
		id: /^\d+$/,
		find: ({ pathname }) => {
			const parts = pathname.split('/').filter(Boolean)
			return parts[0] === 'video' ? parts[1] : parts[0]
		},
		embed: id => `https://player.vimeo.com/video/${id}`,
	},
]

const parseUrl = (text) => {
	try {
		const url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`)
		return [ 'http:', 'https:' ].includes(url.protocol) ? url : null
	} catch {
		// Texto que não forma URL: não é um link de vídeo.
		return null
	}
}

export const videoFromUrl = (text) => {
	const url = typeof text === 'string' ? text.trim() : ''
	const parsed = parseUrl(url)
	if (!parsed) return null
	const hostname = parsed.hostname.toLowerCase()
	for (const { provider, hosts, id, find } of PROVIDERS) {
		if (!hosts.includes(hostname)) continue
		const videoId = find({ hostname, pathname: parsed.pathname, searchParams: parsed.searchParams })
		return videoId && id.test(videoId) ? { url, provider, videoId } : null
	}
	return null
}

// O id vem do conteúdo salvo: só entra na URL do player se tiver o formato do provedor.
export const embedUrl = (provider, videoId) => {
	const found = PROVIDERS.find(item => item.provider === provider)
	return found && typeof videoId === 'string' && found.id.test(videoId) ? found.embed(videoId) : null
}

// `title` do iframe (acessibilidade)
export const videoTitle = (provider) => {
	const found = PROVIDERS.find(item => item.provider === provider)
	return found ? found.title : 'Vídeo'
}
